import { render, staticRenderFns } from "./PeopleCardAdd.vue?vue&type=template&id=4a59cd86&scoped=true&"
import script from "./PeopleCardAdd.vue?vue&type=script&lang=js&"
export * from "./PeopleCardAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a59cd86",
  null
  
)

export default component.exports